import { TFunction } from 'i18next';
import { ContactTypeOption } from './ContactTypeFormSelect.types';
import { ContactType } from '@/api/types/ads.types';

export const getContactTypeOptions = (t: TFunction): ContactTypeOption[] => [
  {
    value: ContactType.CallsAndMessages,
    label: t('pages.new_ad.contact.calls_and_messages'),
  },
  {
    value: ContactType.OnlyCalls,
    label: t('pages.new_ad.contact.only_calls'),
  },
  {
    value: ContactType.OnlyMessages,
    label: t('pages.new_ad.contact.only_messages'),
  },
];
